import React, {ReactNode, useState} from "react";

interface HFSelectProps {
    name: string;
    value: string;
    onChange: (name: string, value: string) => void;
    label: string | undefined;
    options: { value: string, label: string }[];
    tips?: ReactNode;
}

export default function HFSelect({name, value, onChange, label, options, tips = null}: HFSelectProps) {
    const [open, setOpen] = useState(false);

    const currentOption = options.filter(opt => opt.value == value)[0];

    if (label) {
        return (
            <div className="labeled-input">
                <div className="label-group">
                    <label htmlFor={name} className="label">{label}</label>
                    <div className="tips">{tips}</div>
                </div>

                <HFSelectContent name={name} value={value} onChange={onChange} options={options} open={open}
                                 setOpen={setOpen} currentOption={currentOption}/>
            </div>
        );
    } else {
        return (
            <HFSelectContent name={name} value={value} onChange={onChange} options={options} open={open}
                             setOpen={setOpen} currentOption={currentOption}/>
        );
    }
}

function HFSelectContent({name, value, onChange, options, open, setOpen, currentOption}: {
    name: string,
    value: string,
    onChange: (name: string, value: string) => void,
    options: { value: string, label: string }[],
    open: boolean,
    setOpen: (open: boolean) => void,
    currentOption: { value: string, label: string } | undefined
}) {
    return (<>
            <div className="input select"
                 onClick={() => setOpen(!open)}>{currentOption !== undefined ? currentOption.label : "Invalid Option"}</div>

            <div className={"select-options " + (open ? "show" : "")}>
                {options.map(option => (
                    <div key={option.value} onClick={() => {
                        onChange(name, option.value);
                        setOpen(false);
                    }} className={option.value == value ? "text-primary-16" : ""}>{option.label}</div>
                ))}
            </div>
        </>
    );
}